import { useNotifications } from "./UseNotifications";

export const NotificationBadge = () => {
  const [notificationCount] = useNotifications();
  if (notificationCount === 0) return null;
  return <span className="badge badge-notification bg-danger">{notificationCount}</span>;
};

export const NotificationChatBadge = () => {
  const [, notificationChatCount] = useNotifications(false);
  if (notificationChatCount === 0) return null;
  return <span className="badge badge-notification bg-danger">{notificationChatCount}</span>;
};
